export enum Web3Chains {
    Ethereum = 'Ethereum',
    Polygon = 'Polygon',
}

export enum Web3WagmiConnectors {
    Metamask = 'Metamask',
    Ledger = 'Ledger',
    WalletConnect = 'WalletConnect',
}

export enum Web3OtherConnectors {
    Petra = 'Petra',
}

export const availableConnectors = [
    Web3WagmiConnectors.Metamask,
    Web3WagmiConnectors.Ledger,
    Web3WagmiConnectors.WalletConnect,
];
